import financialAccountFormatter from '../utils/formatters/financial-account';
import checkCDV from '../utils/check-cdv';

export default function ebizUiSelect(app) {
	app.directive('ebizUiFinancialSelect', function () {
		return {
			require:  ['uiSelect', 'ngModel'],
			link: function (scope, element, attrs, ngModelCtrl) {
				scope.$watch('$select.selected', function (newValue) {
					scope.$select.search = newValue && newValue[attrs.accountNumberProperty] ? newValue[attrs.accountNumberProperty] : newValue;
				});

				scope.$watch('$select.search', function (newValue, oldValue) {
					var newVal = newValue && newValue[attrs.accountNumberProperty] ? newValue[attrs.accountNumberProperty] : newValue;
					var oldVal = oldValue && oldValue[attrs.accountNumberProperty] ? oldValue[attrs.accountNumberProperty] : oldValue;
					if (attrs.ebizUiFinancialSelect != 'FOREIGN') {
						scope.$select.search = financialAccountFormatter(newVal, oldVal);
					}


					var fitPattern = /^[0-9]{8}-[0-9]{8}(-[0-9]{8})?$/.test(newVal);
					var normalizedBankAccount = newVal ? newVal.replace(/[^0-9]*/g, '') : '';


					if (attrs.ebizUiFinancialSelect != 'FOREIGN') {
						ngModelCtrl[0].ngModel.$setValidity('financialAccountNumberFormat', fitPattern);
						ngModelCtrl[0].ngModel.$setValidity('invalidCDV', checkCDV(normalizedBankAccount));
					}
				});
			}
		};
	});
}
